import { MnemoLoading, Title } from "components/misc";
import { MTable } from "components/table";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Container } from "design-react-kit";
import { BoxDanger } from "components/misc";
import { ROUTES } from "const";
import { dateHelper, networkErrorHelper, stewardService } from "libs";
import { getCurrentRegion, getCurrentCompany } from "store/actions";

class StewardLessonToday extends Component {
  state = {
    loading: false,
    loadingError: "",
    lessonSchedule: [],
    currentRegion: "",
    currentCompany: "",
    rndKey: Math.floor(Math.random() * 1000 + 1), // used to force table re-render
  };

  //--- ---
  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "type",
        Header: "Tipo lezione",
        accessor: "type",
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDate(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
      {
        id: "teacher",
        Header: "Docente",
        accessor: "teacher",
      },
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: (row) => {
          return row?.competitionClass?.length > 10
            ? row.competitionClass.replaceAll(",", ", ")
            : row.competitionClass;
        },
      },
      {
        id: "courseCode",
        Header: "Corsi",
        accessor: "courseCode",
      },
      {
        id: "cntAttendees",
        Header: "Numero Partecipanti",
        accessor: "cntAttendees",
      },
    ],
    actions: [
      {
        id: "qrcodeScan",
        accessor: "id",
        label: "Scansione QrCode",
        icon: "it-camera",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(
            ROUTES.STEWARD_VERIFY_IDENTITY +
              "/" +
              value +
              "/" +
              this.state.lessonSchedule.filter((item) => item.id === value)[0]
                .lessonType,
            "_self"
          );
        },
      },
      {
        id: "qrAttendance",
        accessor: "id",
        label: "Elenco Partecipanti",
        icon: "it-user",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(
            ROUTES.STEWARD_VERIFY_ATTENDANCE +
              "/" +
              value +
              "/" +
              this.state.lessonSchedule.filter((item) => item.id === value)[0]
                .lessonType,
            "_self"
          );
        },
      },
    ],
  };

  componentDidMount() {
    const currentRegion = getCurrentRegion();
    const currentCompany = getCurrentCompany();

    if (currentRegion || currentCompany) {
      this.setState({ currentRegion, currentCompany });
      this.loadRemoteSchedule(currentRegion, currentCompany);
    } else {
      // redirect to dashboard steward
      this.props.history.push(ROUTES.STEWARD_DASHBOARD);
    }
  }

  loadRemoteSchedule(currentRegion, currentCompany) {
    this.setState({ loading: true });
    const searchFilter = {
      date: dateHelper.toUSDate(new Date()),
      region: currentRegion,
      company: currentCompany,
    };

    stewardService
      .lessonOnSiteTrainigSchedule(searchFilter)
      .then(({ data }) => {

        this.setState({
          loading: false,
          lessonSchedule: data.payload.lessonSchedule,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            lessonSchedule: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }
      });
  }

  render() {
    const { loading, currentRegion } = this.state;

    return (
      <>
        <div className="container mt-3 mb-4">
          <section className="my-4">
            <Container>
              <Title>Regione {currentRegion.toUpperCase()}</Title>
            </Container>
          </section>
          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.lessonSchedule}
                  tableConfig={this.tableConfig}
                />
              </Container>
            )}

            {this.state.lessonSchedule.length === 0 && (
              <BoxDanger key="nrp-1" className="my-3">
                <div className="small text-info">Nessun dato disponibile.</div>
              </BoxDanger>
            )}
          </section>
        </div>
      </>
    );
  }
}

export default withRouter(StewardLessonToday);
